import {
	computed, observable, makeObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import { isWeb } from '../utilities/platform';
import RootStore from './root-store';
import { GetLocalStorage, SetLocalStorage } from '../utilities/cryptography';
// import { PACKAGE_PERMISSIONS, USER_INFO } from '../constants/storage-keys';
import { navigate } from 'gatsby';
import { CURRENT_PLATFORM } from '../constants/settings';
import { Gender, PAGE_SIZE } from '../constants/options';
import { ProfileTemplate } from '../utilities/profile';
import { GetLangKey, GetUserProfile, Language } from '../utilities/general';

export default class PackageStore {

	loading: boolean = false;
	loadingFeatures: boolean = false;
	loadingPackages: boolean = false;
	loadingPermissions: boolean = false;
	//   loadingHistory: boolean = false;

	packagePermissions: any = null;

	creating: boolean = false;

	updating: boolean = false;

	//   processingHistory: boolean = false;

	rootStore: RootStore;
	loadingPayment: boolean = false;

	constructor(rootStore: RootStore) {
		makeObservable(this, {
			loading: observable,
			loadingFeatures: observable,
			creating: observable,
			updating: observable,
			loadingPackages: observable,
			loadingPayment: observable,
			loadingPermissions: observable,
			packagePermissions: observable,
		});
		this.rootStore = rootStore;
	}

	searchFeature = async (skip: number, take: number = PAGE_SIZE, reqModel: any = {}, lang: Language = Language.ENGLISH) => {
		this.loadingFeatures = true;
		try {
			const res = await Axios.post(`/api/Package/Feature/Search/${skip}/${take}?lang=${lang}&platformId=${CURRENT_PLATFORM}`, reqModel);
			return Promise.resolve(res.data);
		} catch (err) {
			return Promise.reject(err);
		} finally {
			this.loadingFeatures = false;
		}
	};

	searchPackage = async (skip: number, take: number = PAGE_SIZE, reqModel: any = {}, lang: Language = Language.ENGLISH) => {
		this.loadingPackages = true;
		try {
			const res = await Axios.post(`/api/Package/Search/${skip}/${take}?lang=${lang}&platformId=${CURRENT_PLATFORM}`, reqModel);
			return Promise.resolve(res.data);
		} catch (err) {
			return Promise.reject(err);
		} finally {
			this.loadingPackages = false;
		}
	};



	getPackage = async (id: number, lang: Language = Language.ENGLISH) => {
		this.loading = true;
		try {
			const res = await Axios.get(`/api/Package/${id}?lang=${lang}&platformId=${CURRENT_PLATFORM}`);
			return Promise.resolve(res.data);
		} catch (err) {
			return Promise.reject(err);
		} finally {
			this.loading = false;
		}
	};

	searchMemberPackage = async (skip: number, take: number, reqModel: any = {}) => {
		this.loadingPackages = true;
		try {
			const res = await Axios.post(`/api/Package/Practitioner/Search/${skip}/${take}?platformId=${CURRENT_PLATFORM}`, reqModel);
			return Promise.resolve(res.data);
		} catch (err) {
			return Promise.reject(err);
		} finally {
			this.loadingPackages = false;
		}
	};

	// getMemberPackagePermission = async (memberId: number) => {
	// 	this.loadingPermissions = true;
	// 	try {
	// 		const res = await Axios.get(`/api/Package/Permission?memberId=${memberId}&platformId=${CURRENT_PLATFORM}`);
	// 		this.packagePermissions = res.data;
	// 		let userInfo = GetUserProfile();
	// 		userInfo.packagePermissions = res.data;
	// 		SetLocalStorage(USER_INFO, userInfo);
	// 		// SetLocalStorage(PACKAGE_PERMISSIONS, res.data);
	// 		return Promise.resolve(res.data);
	// 	} catch (err) {
	// 		return Promise.reject(err);
	// 	} finally {
	// 		this.loadingPermissions = false;
	// 	}
	// };

	searchPackagePayment = async (skip: number, take: number = PAGE_SIZE, reqModel: any = {}) => {
		this.loadingPayment = true;
		try {
			const res = await Axios.post(`/api/Package/Payment/Search/${skip}/${take}?platformId=${CURRENT_PLATFORM}`, reqModel);
			return Promise.resolve(res.data);
		} catch (err) {
			return Promise.reject(err);
		} finally {
			this.loadingPayment = false;
		}
	};

}